import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "backdrop"]

  open() {
    this.drawerTarget.classList.add("mobile-drawer--open")
    this.backdropTarget.classList.add("mobile-drawer__backdrop--open")
    document.body.style.overflow = "hidden"
    this._boundKeydown = this._onKeydown.bind(this)
    document.addEventListener("keydown", this._boundKeydown)
  }

  close() {
    this.drawerTarget.classList.remove("mobile-drawer--open")
    this.backdropTarget.classList.remove("mobile-drawer__backdrop--open")
    document.body.style.overflow = ""
    if (this._boundKeydown) {
      document.removeEventListener("keydown", this._boundKeydown)
    }
  }

  _onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  disconnect() {
    document.body.style.overflow = ""
    if (this._boundKeydown) {
      document.removeEventListener("keydown", this._boundKeydown)
    }
  }
}
